<template>
<button class="move-up" :class="{'active':btnVisible}" @click.prevent="scrollToTop"></button>
</template>
<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'

const scrollY = ref(0)
const btnVisible = ref(false)


const handleScroll = () => {
  scrollY.value = window.scrollY
  scrollY.value > 400
  ? btnVisible.value = true
  : btnVisible.value = false
}

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}


onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style lang="scss">
    .move-up{
        width: 50px;
        height: 50px;
        background-color: $violet;
        border-radius: 100%;
        background-image: url('~/assets/svgs/arrow-up.svg');
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 30px;
        border: 2px solid $violet;
        position: fixed;
        bottom: 20px;
        right: 20px;
        opacity: 0;
        pointer-events: none;
        transition: all .2s ease-in-out;
        z-index: 20;
        &.active{
            opacity: 1;
            pointer-events: initial;
            cursor: pointer;
        }
    }
</style>